type ErrorResponse = { response?: { status?: number; data?: { message?: string } } }

export const CONFLICT_MESSAGE = "他の更新があります。再読込してから、もう一度操作してください。"
const NETWORK_MESSAGE =
  "通信に失敗しました。生成を開始していた場合は、再実行の前に履歴を再読込してください。"

/** 複数の時点を続けて保存している途中で失敗した。message は画面にそのまま出す（保存できた分と失敗した時点を伝える） */
export class PartialImportError extends Error {}

/**
 * API エラーを画面の文言にする。409 はロック（lockVersion）の競合なので、サーバの文言ではなく
 * 再読込を促す文言に揃える。422 / 404 はサーバのメッセージをそのまま出す
 */
export const evaluationError = (error: unknown) => {
  if (error instanceof PartialImportError) return error.message
  const response = (error as ErrorResponse)?.response
  if (response?.status === 409) return CONFLICT_MESSAGE
  return response?.data?.message ?? NETWORK_MESSAGE
}

/**
 * サーバが処理したか分からない失敗（応答なし・5xx）。生成はこのときだけ同じ requestKey で再送する。
 * 4xx はサーバが受け付けなかったことが確定しているので、次の生成は新しい意図として扱う
 */
export const isRetryableError = (error: unknown) => {
  const status = (error as ErrorResponse)?.response?.status
  return status === undefined || status >= 500
}

/**
 * ケース一覧を取得できなかったときの文言。検証を止めている環境（DUNNING_EVALUATION_ENABLED がオフ）では
 * サーバが 404 と理由を返すので、それをそのまま出す
 */
export const libraryErrorMessage = (error: unknown) =>
  (error as ErrorResponse)?.response?.data?.message ??
  "ケースを取得できませんでした。接続状態を確認してください。"
